export default __webpack_public_path__ + "c2231967c39d8ec261758770dd2070a7.svg";